// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_aa-3";
export var contentContainer = "_aa-0";
export var editorContainer = "_aa-1";
export var quillInputForm = "_aa-2";
export var zoneDivider = "_aa-4";